import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import { HeroSlice } from './HeroSlice';
import { HeroVariation } from './types';
import { ProspectData } from '@/types/salesforce';

export type HeroProps = SliceComponentProps<Content.HeroSlice, ProspectData>;

const Hero = ({ slice, context }: HeroProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <HeroSlice
        variation={slice.variation as HeroVariation}
        data={slice.primary}
        prospect={context}
      />
    </section>
  );
};

export default Hero;
